module.exports = __webpack_public_path__ + "img/017.1dcba03a.png";